import { BasePluginData } from './base-plugin-data';

/**
 * Represents software configuration for a resource
 */
export class SoftwareData extends BasePluginData {
  override get pluginStepName(): string { return 'SoftwareData'; }

  /**
   * Operating system name (e.g., "windows", "linux")
   */
  os: string = '';

  /**
   * Operating system version (e.g., "win11", "ubuntu20.04")
   */
  osVersion: string = '';

  /**
   * Whether Hyper-V virtualization is enabled
   */
  hyperV: boolean = false;

  /**
   * List of SDKs to install (e.g., "dotnet8", "node20")
   */
  sdks: string[] = [];

  /**
   * List of databases to install (e.g., "mysql8", "postgresql16")
   */
  databases: string[] = [];

  /**
   * List of code editors to install (e.g., "vscode", "intellij")
   */
  editors: string[] = [];

  /**
   * List of miscellaneous software to install
   */
  misc: string[] = [];
}
